<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <h4 class="card-title">{{$t('medium_grant.diligence__6_management_and_pers')}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <label><strong>{{$t('medium_grant.diligence__6_management_financial_pers')}}</strong></label>
        <div>
          <label>{{$t('medium_grant.diligence__6_management_financial_pers_sub')}}</label>
        </div>
        <div class="mt-3"></div>

        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.qualifiedFullTimePersonel">
          {{$t('medium_grant.diligence__6_qualified_fulltime_personel')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.nonFinancePersonel">
          {{$t('medium_grant.diligence__6_non_finance_personel')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.qualifiedParttimePersonel">
          {{$t('medium_grant.diligence__6_qualified_parttime_personel')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.revisionModel.diligence.otherThanStaff">
          {{$t('medium_grant.diligence__6_other_than_staff')}}
        </base-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <label><strong>{{$t('medium_grant.diligence__6_total_number_fulltime_staff')}}</strong></label>
        <div class="mt-3"></div>
        <radio name="diligence.totalNumberFulltimeStaff" value="50" v-model="GrantForm.revisionModel.diligence.totalNumberFulltimeStaff">
          {{$t('medium_grant.diligence__6_fulltimestaff_50')}}
        </radio>
        <radio name="diligence.totalNumberFulltimeStaff" value="1-5" v-model="GrantForm.revisionModel.diligence.totalNumberFulltimeStaff">
          {{$t('medium_grant.diligence__6_fulltimestaff_1_5')}}
        </radio>
        <radio name="diligence.totalNumberFulltimeStaff" value="6-50" v-model="GrantForm.revisionModel.diligence.totalNumberFulltimeStaff">
          {{$t('medium_grant.diligence__6_fulltimestaff_6_50')}}
        </radio>
        <radio name="diligence.totalNumberFulltimeStaff" value="0" v-model="GrantForm.revisionModel.diligence.totalNumberFulltimeStaff">
          {{$t('medium_grant.diligence__6_fulltimestaff_0')}}
        </radio>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <label><strong>{{$t('medium_grant.diligence__6_personel_time_record_keeping')}}</strong></label>
        <div>
          <label>{{$t('medium_grant.diligence__6_personel_time_record_keeping_sub')}}</label>
        </div>
        <div class="mt-3"></div>
        <radio name="diligence.personelTimeRecordKeeping" value="true" v-model="GrantForm.revisionModel.diligence.personelTimeRecordKeeping">
          {{$t('medium_grant.general__yes')}}
        </radio>
        <radio name="diligence.personelTimeRecordKeeping" value="false" v-model="GrantForm.revisionModel.diligence.personelTimeRecordKeeping">
          {{$t('medium_grant.general__no')}}
        </radio>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <label>{{$t('medium_grant.diligence__6_personel_time_record_keeping_sub2')}}</label>
      </div>
      <div class="col-lg-4">
        <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence.revisionOrgTimesheetForm" :file-data="GrantForm.files.diligence.revisionOrgTimesheetForm" :is-editable="GrantForm.isRevisionEditable" :size-limit="GrantForm.fileSizeLimit" section="diligence.revisionOrgTimesheetForm"></upload-file>
      </div>
    </div>

  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style scoped>
  p.white-space-pre {
    white-space: pre-wrap;
  }
</style>
